import {useCallback, useEffect, useRef} from "react";
import {createOfferShownLatch, recipientFunnelEvents} from "./recipientFunnelEvents";

/** Holds the per-instance latch; measured visibility and control events feed the domain emitter. */
export function useRecipientOfferEvents(visible = true): {
	/** The gift was pressed and its popover opened. Stable across renders. */
	reportOpened: () => void;
	/** The claim CTA was followed. Stable across renders. */
	reportClaimed: () => void;
} {
	const latchRef = useRef(createOfferShownLatch());

	useEffect(() => {
		if (latchRef.current.shouldReport(visible)) {
			recipientFunnelEvents.offerShown();
		}
	}, [visible]);

	const reportOpened = useCallback(() => recipientFunnelEvents.offerOpened(), []);
	const reportClaimed = useCallback(() => recipientFunnelEvents.offerClaimed(), []);

	return {reportOpened, reportClaimed};
}
